import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

const IconExclamationMark = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
      <path
        fill={fill}
        opacity={0.2}
        d='M20.057 22H3.943a3.023 3.023 0 0 1-2.618-4.534L9.382 3.511a3.023 3.023 0 0 1 5.236 0l8.057 13.955A3.023 3.023 0 0 1 20.057 22Z'
      />
      <circle cx='12' cy='17' r='1' fill={fill} />
      <path fill={fill} d='M12 14a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1Z' />
    </svg>
  )
}

export default IconExclamationMark
